<template>
  <div>
    <fiscal-form
      @close="$router.push('/client/fiscal/list')"
      @list="$router.push('/client/fiscal/list')"
      @change="id=> $router.push('/client/fiscal/change?id=' + id)"
      @view="id=> $router.push('/client/fiscal/view?id=' + id)"
    />
  </div>
</template>

<script>
  export default {
    props: ['create', 'change', 'view'],
    data: () => ({

    }),
    computed: {

    },
    watch: {

    },
    methods: {

    },
  }
</script>
